/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { observer } from 'mobx-react-lite'

import { useMobxStore } from '../../../state'
import { useLayoutEffect, useMemo } from 'react'
import LoadingSpinner from '../../../components/LoadingSpinner'
import { ConfirmProfile } from './ConfirmProfile'
import { NewTeamRegistration } from './NewTeamRegistration'
import { NewPlayerRegistration } from './NewPlayerRegistration'
import { RegistrationSubmitted } from './RegistrationSubmitted'
import { TeamCreation } from './TeamCreation'
import { PlayerSearchTeam } from './PlayerSearchTeam'

const steps = {
  0: ConfirmProfile,
  1: NewTeamRegistration,
  2: RegistrationSubmitted,
  3: () => <div>Register Failed</div>, // TODO: IMPROVE
  4: PlayerSearchTeam,
  4.5: NewPlayerRegistration,
  5: TeamCreation,
}

export const Main = observer(() => {
  const {
    registrationTypes: {
      fetchTypes
    },
    registrationInvite: {
      state: { eventInfo, step, isLoadingStep },
    },
  } = useMobxStore()

  useLayoutEffect(() => {
    fetchTypes()
  }, [])

  const Step = useMemo(() => steps[step], [step])

  return (
    <div
      css={css`
        display: flex;
        width: 100%;
        height: 100vh;
        background-image: url(${eventInfo?.background_url});
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        justify-content: center;
        align-items: center;
      `}
    >
      <div
        css={css`
          overflow: scroll;
          background-color: ${colors.WHITE};
          height: 100vh;
          padding: 0 35px 35px 35px;
          box-shadow: 0px 0px 26px -5px rgba(0, 0, 0, 0.75);
          display: flex;
          flex-direction: column;
          width: 680px;

          > * {
            color: #000;
          }
        `}
      >
        {isLoadingStep ? (
          <div
            css={css`
              display: flex;
              flex-direction: column;
              flex: 1;
              justify-content: center;
            `}
          >
            <LoadingSpinner />
          </div>
        ) : (
          <Step />
        )}
      </div>
    </div>
  )
})
